import HojasQuirurgicasService from "../../../services/hospitalizacion/HojasQuirurgicasService";

export const generarRecordKey = (record) => {
  const secuencial = record?.cobertura?.secuencial || "";
  const noItem = record?.cobertura?.noItem || "";
  const cobRecl = record?.cobertura?.cobRecl || "";
  const numeroIngreso = record?.estatusCobertura?.numeroIngreso || "";
  
  return `${numeroIngreso}-${secuencial}-${noItem}-${cobRecl}`;
};

const obtenerDetallesCoberturas = async (secuencial) => {
  try {
    const consultarDetalleCoberturaData = {
      requestParams: { secuencial },
    };
    const coberturasResponse =
      await HojasQuirurgicasService.consultarDetalleCobertura(
        consultarDetalleCoberturaData
      );
    return coberturasResponse?.data?.coberturas || [];
  } catch (error) {
    console.error(
      `Error al obtener detalles de coberturas para secuencial ${secuencial}:`,
      error
    );
    return [];
  }
};

const obtenerTodosLosAnexos = async (secuencial) => {
  try {
    const todosLosAnexos = [];
    let paginaActual = 1;
    let totalPaginas = 1;
    const tamanoPagina = 10;

    do {
      const consultarDetalleAnexosData = {
        requestParams: {
          secuencial,
          pagina: paginaActual,
          tamanoPagina,
        },
      };
      const anexosResponse =
        await HojasQuirurgicasService.consultarDetalleAnexos(
          consultarDetalleAnexosData
        );

      if (anexosResponse?.data?.anexos) {
        todosLosAnexos.push(...anexosResponse.data.anexos);
      }

      totalPaginas = anexosResponse?.data?.totalPaginas || 1;
      paginaActual++;
    } while (paginaActual <= totalPaginas);

    return todosLosAnexos;
  } catch (error) {
    console.error(
      `Error al obtener detalles de anexos para secuencial ${secuencial}:`,
      error
    );
    return [];
  }
};

const construirFechaHora = (fecha, hora) => {
  if (!fecha) return "";
  if (fecha.includes("T")) return fecha;
  if (hora) return `${fecha}T${hora}`;
  return fecha;
};

const compararFechas = (a, b) => {
  const fechaA = a?.estatusCobertura?.fechaTransaccion || "";
  const horaA = a?.estatusCobertura?.horaTransaccion || "";
  const fechaB = b?.estatusCobertura?.fechaTransaccion || "";
  const horaB = b?.estatusCobertura?.horaTransaccion || "";

  const fechaHoraA = construirFechaHora(fechaA, horaA);
  const fechaHoraB = construirFechaHora(fechaB, horaB);

  if (!fechaHoraA && !fechaHoraB) return 0;
  if (!fechaHoraA) return 1;
  if (!fechaHoraB) return -1;

  const dateA = new Date(fechaHoraA);
  const dateB = new Date(fechaHoraB);

  if (isNaN(dateA.getTime()) && isNaN(dateB.getTime())) return 0;
  if (isNaN(dateA.getTime())) return 1;
  if (isNaN(dateB.getTime())) return -1;

  return dateB.getTime() - dateA.getTime();
};

const eliminarDuplicados = (registros) => {
  const registrosUnicos = new Map();
  registros.forEach((record) => {
    const key = generarRecordKey(record);
    if (!registrosUnicos.has(key)) {
      registrosUnicos.set(key, record);
    }
  });
  return Array.from(registrosUnicos.values());
};

const procesarSecuencial = async (secuencial, estatusCoberturas) => {
  const [detallesCoberturas, detallesAnexos] = await Promise.all([
    obtenerDetallesCoberturas(secuencial),
    obtenerTodosLosAnexos(secuencial),
  ]);

  const estatusCobertura = estatusCoberturas.find(
    (item) => item.secuencial === secuencial
  );

  return detallesCoberturas.map((cobertura) => {
    const anexosFiltrados = detallesAnexos.filter(
      (anexo) => anexo.coberturaReclamada === cobertura.cobRecl
    );

    return {
      cobertura,
      estatusCobertura,
      anexos: anexosFiltrados,
    };
  });
};

export const mapearRegistros = async (estatusCoberturas) => {
  if (!estatusCoberturas || estatusCoberturas.length === 0) {
    return [];
  }

  const secuencialesUnicos = [
    ...new Set(estatusCoberturas.map((item) => item.secuencial).filter(Boolean)),
  ];

  const mapeoCompleto = await Promise.all(
    secuencialesUnicos.map((secuencial) =>
      procesarSecuencial(secuencial, estatusCoberturas)
    )
  );

  const registrosPlano = mapeoCompleto.flat();
  const registrosSinDuplicados = eliminarDuplicados(registrosPlano);
  registrosSinDuplicados.sort(compararFechas);

  return registrosSinDuplicados;
};

export const construirRequestParams = (
  codigoPss,
  numeroIngreso,
  fechaInicio,
  fechaFin,
  pagina = 1,
  tamanoPagina = 10
) => {
  const requestParams = {
    codigoPss,
    pagina,
    tamanoPagina,
  };

  if (numeroIngreso?.trim()) {
    requestParams.numeroIngreso = numeroIngreso;
  }

  if (fechaInicio?.trim()) {
    requestParams.fechaInicio = fechaInicio;
  }

  if (fechaFin?.trim()) {
    requestParams.fechaFin = fechaFin;
  }

  return requestParams;
};

